import { useLanguage } from '../context/LanguageContext';
import esCommon from '../locales/es/common.json';
import enCommon from '../locales/en/common.json';
import esPages from '../locales/es/pages.json';
import enPages from '../locales/en/pages.json';
import esPaintings from '../locales/es/paintings.json';
import enPaintings from '../locales/en/paintings.json';
import esBooks from '../locales/es/books.json';
import enBooks from '../locales/en/books.json';

const translations = {
  es: {
    ...esPages,
    ...esCommon,
    ...esPaintings,
    ...esBooks,
  },
  en: {
    ...enPages,
    ...enCommon,
    ...enPaintings,
    ...enBooks,
  },
};

export const useTranslation = () => {
  const { language } = useLanguage();
  
  const t = (key, params = {}) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    if (!value) {
      // Fallback to Spanish if translation not found
      value = translations.es;
      for (const k of keys) {
        value = value?.[k];
      }
          if (!value) return key;
    }
    
    // Replace parameters
    return Object.keys(params).reduce((str, param) => {
      return str.replace(`{${param}}`, params[param]);
    }, value);
  };
  
  return { t, language };
}; 